import { IsBoolean, IsDate, IsNumber, IsString } from 'class-validator';
import { BaseDto } from './base.dto';
import { CurrencyDto } from './currency.dto';
import { MerchantDto } from './merchant.dto';

export class ExchangeRateDto extends BaseDto {
  
  @IsNumber()
  merchantId: number;

  @IsNumber()
  fromCurrencyId: number;

  @IsNumber()
  toCurrencyId: number;

  @IsDate()
  effectiveFrom: Date;

  @IsNumber()
  exchangeRate: number;

  @IsString()
  status: string;

  @IsBoolean()
  isActive?: boolean;

  fromCurrency: CurrencyDto;
  toCurrency: CurrencyDto;
  merchant: MerchantDto;
}
